<template>
  <div>
    <b-breadcrumb>
      <b-breadcrumb-item>YOU ARE HERE</b-breadcrumb-item>
      <b-breadcrumb-item>
        <router-link tag="a" to="/app/sfc-actual-activity"
          >Actual Activity</router-link
        >
      </b-breadcrumb-item>
      <b-breadcrumb-item active>{{ formName }}</b-breadcrumb-item>
    </b-breadcrumb>

    <b-list-group flush>
      <b-list-group-item>
        <b-row align-h="start">
          <b-col sm="12">
            <b-form-group
              label="Project ID"
              label-for="Project ID"
              label-cols-sm="3"
              label-align-sm="left"
              label-size="sm"
            >
              <b-form-input
                id="Project ID"
                :disabled="true"
                v-model="ProjectID"
                trim
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col sm="12">
            <b-form-group
              label="Customer Name"
              label-for="CustomerName"
              label-cols-sm="3"
              label-align-sm="left"
              label-size="sm"
            >
              <b-form-input
                id="CustomerName"
                :disabled="true"
                v-model="form.customer_name"
                trim
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row align-h="start">
          <b-col sm="12">
            <b-form-group
              label="Actual Date"
              label-for="ActualDate"
              label-cols-sm="3"
              label-align-sm="left"
              label-size="sm"
            >
              <v-date-picker
                class="inline-block h-full"
                v-model="form.actual_date"
                color="indigo"
                mode="dateTime"
                :timezone="timezone"
                :min-date="NowDate"
                :max-date="new Date()"
                :masks="masks"
              >
                <template v-slot="{ inputValue, inputEvents }">
                  <div class="flex items-center" v-on="inputEvents">
                    <button
                      class="p-1 bg-blue-100 border border-blue-200 hover:bg-blue-200 text-blue-600 rounded-l focus:bg-blue-500 focus:text-white focus:border-blue-500 focus:outline-none"
                    >
                      <b-icon
                        scale="1"
                        style="color: black"
                        icon="calendar3"
                      ></b-icon>
                    </button>
                    <input
                      style="width: 77%"
                      :value="inputValue"
                      class="bg-white text-gray-700 w-full py-1 px-2 appearance-none border rounded-r focus:outline-none focus:border-blue-500"
                      readonly
                    />
                  </div>
                </template>
              </v-date-picker>
              <!-- <VueDatePicker
                                style="border: 1px solid #c1ccd3;border-radius: 0.3rem; margin-bottom:5px;"
                                class="vd__div"
                                :required="true"
                                v-model="form.actual_date"
                                no-header
                                format="ddd D MMM YYYY"
                                placeholder="Choose date"
                                :min-date="NowDate"
                                />
                                <b-time
                                    v-model="form.actual_time"
                                    locale="en"
                                    :hour12="false"
                                    :isRTL="true"
                                    :hide-header="true"
                                    @context="onContext"
                                >
                                </b-time> -->
            </b-form-group>
          </b-col>
        </b-row>
        <b-row align-h="start">
          <b-col sm="12">
            <b-form-group
              label="Actual"
              label-for="Actual"
              label-cols-sm="3"
              label-align-sm="left"
              label-size="sm"
            >
              <div style="display: flex">
                <multiselect
                  v-model="SelectActivity"
                  :disabled="DisableActivity"
                  tag-placeholder="Add this as new tag"
                  placeholder="Search or add Activity"
                  label="name"
                  @input="InputActivity"
                  :options="optionsActivity"
                  track-by="name"
                  openDirection="bottom"
                  :multiple="true"
                  :taggable="true"
                >
                </multiselect>
                <b-button
                  v-if="ButtonChange"
                  @click="changeActivity"
                  variant="light"
                  style="background: #fff0; display: flex"
                >
                  <b-icon
                    scale="0.7"
                    style="color: black"
                    icon="pencil-fill"
                  ></b-icon>
                </b-button>
              </div>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row align-h="start" v-if="hiddenOptions">
          <b-col sm="12">
            <b-form-group
              label="Options"
              label-for="Options"
              label-cols-sm="3"
              label-align-sm="left"
              label-size="sm"
            >
              <v-select
                append-to-body
                :clearable="false"
                :reduce="(data) => data.name"
                v-model="form.sub_activity_name"
                @input="InputSubActivity"
                :options="optionsSubActivity"
                placeholder="Select Your Options"
                label="name"
              >
              </v-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row align-h="start" v-if="hiddenPOID">
          <b-col sm="12">
            <b-form-group
              label="PO ID"
              label-for="PO ID"
              label-cols-sm="3"
              label-align-sm="left"
              label-size="sm"
            >
              <b-form-input id="POID" v-model="form.po_id" trim></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row align-h="start" v-if="hiddenReason">
          <b-col sm="12">
            <b-form-group
              label="Reason"
              label-for="Reason"
              label-cols-sm="3"
              label-align-sm="left"
              label-size="sm"
            >
              <v-select
                append-to-body
                :clearable="false"
                :reduce="(data) => data.reason"
                v-model="form.reason"
                :options="optionsReason"
                placeholder="Select Your Reason"
                label="reason"
              >
              </v-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row align-h="start">
          <b-col sm="12">
            <b-form-group
              label="Remark"
              label-for="Remark"
              label-cols-sm="3"
              label-align-sm="left"
              label-size="sm"
            >
              <b-form-textarea
                id="textarea-no-resize"
                placeholder="Enter Your Remarks..."
                rows="3"
                v-model="form.remark"
                no-resize
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
        <br />
      </b-list-group-item>

      <!-- Sales Projection -->
      <b-list-group-item>
        <accordion>
          <accordion-item :startActive="true">
            <!-- This slot will handle the title/header of the accordion and is the part you click on -->
            <template slot="accordion-trigger">
              <h4>
                Sales Projection
                <b-icon
                  scale="2"
                  style="
                    color: black;
                    position: relative;
                    padding: 5px;
                    top: 2px;
                  "
                  icon="chevron-down"
                ></b-icon>
                <span
                  id="warning-sales_projection"
                  style="margin-left: 10px"
                  class="display-hidden text-small text-danger"
                  >Required
                </span>
              </h4>
            </template>
            <!-- This slot will handle all the content that is passed to the accordion -->
            <template slot="accordion-content">
              <br />
              <b-row align-h="start">
                <!-- EstShipmentMonth -->
                <b-col sm="12">
                  <b-form-group
                    label="Est Shipment Month"
                    label-for="EstShipmentMonth"
                    label-cols-sm="3"
                    label-align-sm="left"
                    label-size="sm"
                  >
                    <VueDatePicker
                      v-model="form.estShipMonth"
                      class="vd__div"
                      no-header
                      placeholder="Choose Month"
                      :min-date="NowDate"
                      type="month"
                    >
                      <template #input-icon>
                        <b-icon
                          scale="1"
                          style="color: black"
                          icon="calendar3"
                        ></b-icon>
                      </template>
                    </VueDatePicker>
                    <span
                      id="warning-shipment"
                      class="display-hidden text-small text-danger"
                    >
                      Required
                    </span>
                  </b-form-group>
                </b-col>
              </b-row>

              <!-- Project Status -->
              <b-row align-h="start">
                <b-col sm="12">
                  <b-form-group
                    label="Project Status"
                    label-for="ProjectStatus"
                    label-cols-sm="3"
                    label-align-sm="left"
                    label-size="sm"
                  >
                    <v-select
                      append-to-body
                      :clearable="false"
                      :reduce="(data) => data.value"
                      v-model="form.statusCustomer"
                      :options="optionsStatusCustomer"
                      placeholder="Select Project Status"
                      label="value"
                    >
                    </v-select>
                    <span
                      id="warning-projectStatus"
                      class="display-hidden text-small text-danger"
                    >
                      Required
                    </span>
                  </b-form-group>
                </b-col>
              </b-row>

              <!-- Item Products  -->
              <b-row align-h="start">
                <b-col sm="12">
                  <b-form-group
                    label="Products"
                    label-for="Products"
                    label-cols-sm="3"
                    label-align-sm="left"
                    label-size="sm"
                  >
                    <b-row
                      style="
                        margin: 0px;
                        margin-top: 5px;
                        font-size: 10px;
                        font-weight: 600;
                      "
                    >
                      <div style="display: contents; font-weight: 600">
                        <span style="width: 20%; padding-bottom: 10px">
                          Name
                        </span>
                        <span style="width: 10%; padding-bottom: 10px">
                          Color
                        </span>
                        <span style="width: 7%; padding-bottom: 10px">
                          Intencity
                        </span>
                        <span style="width: 8%; padding-bottom: 10px">
                          Brand
                        </span>
                        <span style="width: 25%; padding-bottom: 10px">
                          Material
                        </span>
                        <span style="width: 5%; padding-bottom: 10px">
                          Qty
                        </span>
                        <span style="width: 10%; padding-bottom: 10px">
                          Est Price
                        </span>
                        <span style="width: 10%; padding-bottom: 10px">
                          Est Cogs
                        </span>
                        <span
                          v-if="!lockSalesProjection"
                          style="
                            width: 5%;
                            text-align: end;
                            padding-bottom: 10px;
                          "
                          @click="AddItem()"
                        >
                          <!-- <span style="position: absolute; right: 0px;">Add</span> -->
                          <b-icon
                            scale="1.5"
                            style="color: green; position: relative"
                            icon="plus-square"
                            title="add"
                          ></b-icon>
                        </span>
                      </div>
                      <br />
                      <div
                        v-for="(row, index) in dataItemProducts"
                        :key="index"
                        style="display: contents; margin: 0px; font-size: 9px"
                      >
                        <span
                          v-if="row.type != 'delete'"
                          style="width: 20%; padding-top: 5px"
                        >
                          {{ row.category }}-{{ row.item }}</span
                        >
                        <span
                          v-if="row.type != 'delete'"
                          style="width: 10%; padding-top: 5px"
                        >
                          {{ row.color }}-{{ row.color_name }}</span
                        >
                        <span
                          v-if="row.type != 'delete'"
                          style="width: 7%; padding-top: 5px"
                        >
                          {{ row.intencity }}-{{ row.intencity_name }}</span
                        >
                        <span
                          v-if="row.type != 'delete'"
                          style="width: 8%; padding-top: 5px"
                        >
                          {{ row.brand_name }}</span
                        >
                        <span
                          v-if="row.type != 'delete'"
                          style="width: 25%; padding-top: 5px"
                        >
                          {{ row.material_name }}</span
                        >
                        <span
                          v-if="row.type != 'delete'"
                          style="width: 5%; padding-top: 5px"
                        >
                          {{ row.qty }}
                        </span>
                        <span
                          v-if="row.type != 'delete'"
                          style="width: 10%; padding-top: 5px"
                        >
                          {{
                            parseFloat(row.est_item_price)
                              .toFixed(2)
                              .toString()
                              .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
                          }}
                        </span>
                        <span
                          v-if="row.type != 'delete'"
                          style="width: 10%; padding-top: 5px"
                        >
                          {{
                            parseFloat(row.est_cogs)
                              .toFixed(2)
                              .toString()
                              .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
                          }}
                        </span>
                        <span
                          v-if="row.type != 'delete'"
                          style="width: 5%; text-align: end; padding-top: 5px"
                        >
                          <!-- <span style="position: absolute; right: 0px;">Add</span> -->
                          <b-icon
                            v-if="!lockSalesProjection"
                            @click="editItem(row, index)"
                            scale="1.3"
                            style="
                              color: goldenrod;
                              position: relative;
                              right: 20px;
                            "
                            icon="pencil-fill"
                            title="edit"
                          ></b-icon>
                          <b-icon
                            v-if="!lockSalesProjection"
                            @click="removeItem(index)"
                            scale="1.3"
                            style="color: red; position: relative"
                            icon="trash-fill"
                            title="delete"
                          ></b-icon>
                        </span>
                      </div>
                    </b-row>
                    <span
                      id="warning-products"
                      class="display-hidden text-small text-danger"
                    >
                      Required
                    </span>
                  </b-form-group>
                </b-col>
              </b-row>

              <!-- Revenue -->
              <b-row align-h="start">
                <b-col sm="12">
                  <b-form-group
                    label="Revenue"
                    label-for="revenueValue"
                    label-cols-sm="3"
                    label-align-sm="left"
                    label-size="sm"
                  >
                    <b-form-input
                      v-model="revenueValue"
                      type="text"
                      :readonly="true"
                      trim
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>

              <!-- GP Value -->
              <b-row align-h="start">
                <b-col sm="12">
                  <b-form-group
                    label="GP Value"
                    label-for="GPValue"
                    label-cols-sm="3"
                    label-align-sm="left"
                    label-size="sm"
                  >
                    <b-form-input
                      v-model="GpValue"
                      type="text"
                      :readonly="true"
                      trim
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>

              <!-- GP Percent -->
              <b-row align-h="start">
                <b-col sm="12">
                  <b-form-group
                    label="GP %"
                    label-for="GpPercent"
                    label-cols-sm="3"
                    label-align-sm="left"
                    label-size="sm"
                  >
                    <b-form-input
                      v-model="GpPercent"
                      type="text"
                      :readonly="true"
                      trim
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
            </template>
          </accordion-item>
        </accordion>
      </b-list-group-item>

      <!-- Measurements Recap -->
      <b-list-group-item v-if="lockSPKPO">
        <accordion>
          <accordion-item :startActive="false">
            <!-- This slot will handle the title/header of the accordion and is the part you click on -->
            <template slot="accordion-trigger">
              <h4>
                Measurement Recap
                <b-icon
                  scale="2"
                  style="
                    color: black;
                    position: relative;
                    padding: 5px;
                    top: 2px;
                  "
                  icon="chevron-down"
                ></b-icon>
                <span
                  id="warning-measurementRecap"
                  style="margin-left: 10px"
                  class="display-hidden text-small text-danger"
                  >Required
                </span>
              </h4>
            </template>
            <!-- This slot will handle all the content that is passed to the accordion -->
            <template slot="accordion-content">
              <b-icon
                @click="addPartRecap()"
                scale="1.3"
                style="color: green; margin-right: 10px"
                icon="plus-square"
                title="add partial"
              ></b-icon>
              <br />
              <br />
              <div v-for="(len, index) in dataItemUkurProducts" :key="index">
                <b-icon
                  @click="deletePartRecap(len.part_no, len.id)"
                  scale="1"
                  style="color: red; margin-right: 10px"
                  icon="trash-fill"
                  title="delete partial"
                ></b-icon>
                <span> Part {{ len.part_no }} :</span>

                <!-- Item Products Recap  -->
                <b-row align-h="start">
                  <b-col sm="12">
                    <b-form-group
                      label="Recap"
                      label-for="Recap"
                      label-cols-sm="3"
                      label-align-sm="left"
                      label-size="sm"
                    >
                      <b-row
                        style="
                          margin: 0px;
                          margin-top: 5px;
                          font-size: 12px;
                          font-weight: 600;
                        "
                      >
                        <div style="display: contents; font-weight: 600">
                          <span style="width: 10%; padding-bottom: 10px">
                            <b-icon
                              @click="getAllListItem(len.part_no)"
                              scale="1.8"
                              style="color: cornflowerblue"
                              icon="card-list"
                              title="get all list"
                            ></b-icon>
                          </span>
                          <span style="width: 16%; padding-bottom: 10px">
                            Article
                          </span>
                          <span style="width: 30%; padding-bottom: 10px">
                            Name
                          </span>
                          <span style="width: 17%; padding-bottom: 10px">
                            Color
                          </span>
                          <span style="width: 17%; padding-bottom: 10px">
                            Intencity
                          </span>
                          <span style="width: 10%; padding-bottom: 10px">
                            Qty
                          </span>
                        </div>
                        <br />
                        <div
                          v-for="(row, index) in len.item"
                          :key="index"
                          style="
                            display: contents;
                            margin: 0px;
                            font-size: 10px;
                          "
                        >
                          <span
                            style="
                              width: 10%;
                              text-align: start;
                              padding-top: 5px;
                            "
                          >
                            <!-- <span style="position: absolute; right: 0px;">Add</span> -->
                            <b-icon
                              @click="showItemRecap(row, index)"
                              scale="1.5"
                              style="color: purple; position: relative"
                              icon="eye-fill"
                              title="view"
                            ></b-icon>
                            <b-icon
                              v-if="!lockMeasurementRecap"
                              @click="editItemRecap(row)"
                              scale="1.5"
                              style="
                                color: goldenrod;
                                position: relative;
                                left: 15px;
                              "
                              icon="pencil-fill"
                              title="edit"
                            ></b-icon>
                            <b-icon
                              v-if="lockMeasurementRecap"
                              @click="unlock(row)"
                              scale="1.5"
                              style="
                                color: cornflowerblue;
                                position: relative;
                                left: 15px;
                              "
                              icon="unlock-fill"
                              title="unlock"
                            ></b-icon>
                            <b-icon
                              v-if="!lockMeasurementRecap"
                              @click="deleteItemRecap(row)"
                              scale="1.5"
                              style="color: red; position: relative; left: 30px"
                              icon="trash-fill"
                              title="delete"
                            ></b-icon>
                          </span>
                          <span style="width: 16%; padding-top: 5px">
                            {{ row.article }}</span
                          >
                          <span style="width: 30%; padding-top: 5px">
                            {{ row.category }} - {{ row.item }}</span
                          >
                          <span style="width: 17%; padding-top: 5px">
                            {{ row.color }} - {{ row.color_name }}</span
                          >
                          <span style="width: 17%; padding-top: 5px">
                            {{ row.intencity }} - {{ row.intencity_name }}</span
                          >
                          <span style="width: 10%; padding-top: 5px">
                            {{ row.qty }}
                          </span>
                        </div>
                      </b-row>

                      <br />

                      <b-row
                        style="margin: 0px; margin-top: 5px; font-size: 12px"
                      >
                        <div
                          style="
                            display: contents;
                            margin: 0px;
                            background: gray;
                            font-size: 13px;
                            font-weight: 600;
                          "
                        >
                          <span style="width: 75%; position: relative"
                            >Total</span
                          >
                          <span style="width: 10%; position: relative">{{
                            len.total
                          }}</span>
                        </div>
                      </b-row>
                    </b-form-group>
                  </b-col>
                </b-row>
              </div>
            </template>
          </accordion-item>
        </accordion>
      </b-list-group-item>

      <!-- Upload Measurements -->
      <b-list-group-item v-if="lockSPKPO">
        <accordion>
          <accordion-item :startActive="false">
            <!-- This slot will handle the title/header of the accordion and is the part you click on -->
            <template slot="accordion-trigger">
              <h4>
                Upload Measurements
                <b-icon
                  scale="2"
                  style="
                    color: black;
                    position: relative;
                    padding: 5px;
                    top: 2px;
                  "
                  icon="chevron-down"
                ></b-icon>
                <span
                  id="warning-uploadMeasurement "
                  style="margin-left: 10px"
                  class="display-hidden text-small text-danger"
                  >Required
                </span>
              </h4>
            </template>
            <!-- This slot will handle all the content that is passed to the accordion -->
            <template slot="accordion-content">
              <br />
              <div
                v-for="(dat, index1) in dataRecapMeasurement"
                :key="index1"
                style="border-bottom: 1px solid #ccc; margin-bottom: 25px"
              >
                <!-- Item Products Recap  -->
                <b-row align-h="start">
                  <b-col sm="12">
                    <b-form-group
                      :label="`Measurement Recap Data Part ${dat.part_no} :`"
                      label-for="Products"
                      label-cols-sm="3"
                      label-align-sm="left"
                      label-size="sm"
                    >
                      <b-row
                        style="margin: 0px; margin-top: 5px; font-size: 12px"
                      >
                        <div style="display: contents; font-weight: 600">
                          <span style="width: 35%; padding-bottom: 10px">
                            Name
                          </span>
                          <span style="width: 25%; padding-bottom: 10px">
                            Article
                          </span>
                          <span style="width: 15%; padding-bottom: 10px">
                            Size
                          </span>
                          <span style="width: 15%; padding-bottom: 10px">
                            Qty
                          </span>
                        </div>
                        <br />
                        <div
                          v-for="(row, index2) in dat.item"
                          :key="index2"
                          style="
                            display: contents;
                            margin: 0px;
                            font-size: 11px;
                          "
                        >
                          <span style="width: 35%; padding-top: 5px">
                            {{ row.category }}-{{ row.item }}</span
                          >
                          <span style="width: 25%; padding-top: 5px">
                            {{ row.article }}</span
                          >
                          <span style="width: 15%; padding-top: 5px">
                            {{ row.size }}
                          </span>
                          <span style="width: 15%; padding-top: 5px">
                            {{ row.qty }}
                          </span>
                        </div>
                      </b-row>
                      <br />
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row align-h="start">
                  <b-col sm="6">
                    <b-form-group
                      label="Qty PO"
                      label-for="Products"
                      label-cols-sm="8"
                      label-align-sm="left"
                      label-size="sm"
                    >
                      <b-form-input
                        :value="dat.total"
                        :readonly="true"
                        trim
                      ></b-form-input>
                      <span
                      :id="'warning-qtypo' + index1"
                      class="display-hidden text-small text-danger"
                    >
                      Required
                    </span>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row align-h="start">
                  <b-col sm="6">
                    <b-form-group
                      label="Box Type"
                      label-for="Products"
                      label-cols-sm="8"
                      label-align-sm="left"
                      label-size="sm"
                    >
                      <v-select
                        :clearable="false"
                        :reduce="(data) => data.name"
                        v-model="boxType[index1]"
                        :options="optionsBoxType"
                        placeholder="Select BOX"
                        label="name"
                      >
                      </v-select>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row align-h="start">
                  <b-col sm="6">
                    <b-form-group
                      label="Rule Type"
                      label-for="Products"
                      label-cols-sm="8"
                      label-align-sm="left"
                      label-size="sm"
                    >
                      <v-select
                        :clearable="false"
                        v-model="ruleType[index1]"
                        :options="optionsRuleType"
                        placeholder="Select Rule"
                        label="name"
                      >
                      </v-select>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row align-h="end">
                  <b-button
                    variant="secondary"
                    style="color: white; margin-right: 10px"
                    @click="btnDownloadMeasurement()"
                  >
                    Download
                  </b-button>
                  <b-form-file
                    id="fileSizeSpec"
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    v-model="fileUploadMea"
                    @input="uploadMeasurement()"
                    class="display-hidden"
                  ></b-form-file>
                  <b-button
                    variant="primary"
                    style="margin-right: 10px"
                    @click="btnUploadMeasurement(dat)"
                  >
                    Upload
                  </b-button>
                </b-row>

                <br />

                <b-row align-h="start">
                  <b-col sm="12">
                    <b-form-group
                      label="Measurement Data"
                      label-for="Products"
                      label-cols-sm="3"
                      label-align-sm="left"
                      label-size="sm"
                    >
                      <b-row
                        style="margin: 0px; margin-top: 5px; font-size: 12px"
                      >
                        <div style="display: contents; font-weight: 600">
                          <span style="padding-bottom: 10px; width: 15%">
                            Action
                          </span>
                          <span style="padding-bottom: 10px; width: 45%">
                            Name
                          </span>
                          <span style="width: 25%; padding-bottom: 10px">
                            Article
                          </span>
                          <span style="width: 5%; padding-bottom: 10px">
                            Total
                          </span>
                        </div>
                        <br />
                        <div
                          v-for="(row, index) in dataUploadMeasurement[index1].item"
                          :key="index"
                          style="
                            display: contents;
                            margin: 0px;
                            font-size: 11px;
                          "
                        >
                          <span style="padding-bottom: 10px; width: 15%">
                            <b-button
                              variant="outline-info"
                              size="xs"
                              @click="loadDetailBox(row)"
                            >
                              Detail
                            </b-button>
                          </span>
                          <span
                            class="windowMobnm"
                            style="padding-bottom: 10px; width: 45%"
                          >
                            {{ row.category }} - {{ row.item }}
                          </span>
                          <span style="width: 25%; padding-bottom: 10px">
                            {{ row.article }}
                          </span>
                          <span
                            style="
                              width: 5%;
                              padding-bottom: 10px;
                              text-align: center;
                            "
                          >
                            {{ row.total }}
                          </span>
                        </div>
                      </b-row>
                      <br />
                    </b-form-group>
                  </b-col>
                </b-row>

                <br />

                <b-row
                  align-h="start"
                  v-if="uploadFail"
                  style="border-top:1px solid #EEE;"
                >
                  <b-col sm="12">
                    <b-form-group
                      label="Log Fail Data"
                      label-for="Products"
                      label-cols-sm="3"
                      label-align-sm="left"
                      label-size="sm"
                    >
                      <b-row
                        style="margin: 0px; margin-top: 5px; font-size: 12px"
                      >
                        <div style="display: contents; font-weight: 600">
                          <span
                            class="windowMobac"
                            style="padding-bottom: 10px; width: 90%"
                          >
                            Error
                          </span>
                          <span style="width: 10%; padding-bottom: 10px">
                            Size
                          </span>
                        </div>
                        <br />
                        <div
                          v-for="(row, index) in dataErrorUpload[index1].item"
                          :key="index"
                          style="
                            display: contents;
                            margin: 0px;
                            font-size: 11px;
                          "
                        >
                          <span
                            class="windowMobac"
                            style="padding-bottom: 10px; width: 90%"
                          >
                            {{ row.error }}
                          </span>
                          <span style="width: 10%; padding-bottom: 10px">
                            {{ row.size }}
                          </span>
                        </div>
                      </b-row>
                      <br />
                    </b-form-group>
                  </b-col>
                </b-row>
              </div>
            </template>
          </accordion-item>
        </accordion>
      </b-list-group-item>
    </b-list-group>
    <br />
    <b-row align-h="end">
      <b-button
        style="margin-right: 20px"
        variant="success"
        @click="Confirm('Submit')"
      >
        Submit</b-button
      >
      <b-button variant="warning" @click="cancel()"> Cancel</b-button>
    </b-row>

    <template>
      <b-modal
        v-model="showDetailBox"
        ok-variant="success"
        cancel-variant="warning"
        header-bg-variant="secondary"
        hide-footer
        hide-header-close
        hide-backdrop
        size="sm"
        no-close-on-backdrop
        title="Data Box Ukur"
      >
        <div id="modal">
          <b-row>
            <b-col cols="3">
              <span> Article </span>
            </b-col>
            <b-col cols="9">
              <span>: {{ detailArticle }} </span>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="3">
              <span> Category </span>
            </b-col>
            <b-col cols="9">
              <span>: {{ detailCategory }} </span>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="3">
              <span> Item </span>
            </b-col>
            <b-col cols="9">
              <span>: {{ detailItem }} </span>
            </b-col>
          </b-row>
          <!-- <b-row>
            <b-col cols="3">
              <span> Position </span>
            </b-col>
            <b-col cols="9">
              <span>: {{ detailPosition }} </span>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="3">
              <span> Address </span>
            </b-col>
            <b-col cols="9">
              <span>: {{ detailAddress }} </span>
            </b-col>
          </b-row>

          <br /> -->

          <b-row style="margin: 0px; margin-top: 5px; font-size: 12px">
            <div style="display: contents; font-weight: 600">
              <!-- <span style="width: 25%; padding-bottom: 10px"> Category </span>
              <span style="width: 25%; padding-bottom: 10px"> Item </span> -->
              <span style="width: 75%; padding-bottom: 10px"> Size </span>
              <span style="width: 15%; padding-bottom: 10px"> Total </span>
            </div>
            <br />
            <div
              v-for="(row, index) in dataDetailTable"
              :key="index"
              style="display: contents; margin: 0px; font-size: 11px"
            >
              <!-- <span style="width: 25%; padding-bottom: 10px">
                {{ row.category }}
              </span>
              <span style="width: 25%; padding-bottom: 10px">
                {{ row.item }}
              </span> -->
              <span style="width: 75%; padding-bottom: 10px">
                {{ row.size }}
              </span>
              <span style="width: 25%; padding-bottom: 10px">
                {{ row.total }}
              </span>
            </div>
          </b-row>

          <b-row align-h="end">
            <b-col sm="6">
              <b-button
                block
                size="md"
                @click="cancelDetail()"
                type="button"
                variant="warning"
              >
                Cancel
              </b-button>
            </b-col>
          </b-row>
        </div>
      </b-modal>
    </template>

    <template>
      <b-modal
        v-model="showRecap"
        ok-variant="success"
        cancel-variant="warning"
        header-bg-variant="secondary"
        hide-footer
        hide-header-close
        hide-backdrop
        size="md"
        no-close-on-backdrop
        title="Data Part Ukur"
      >
        <div id="modal">
          <!-- Products -->
          <b-row>
            <b-col sm="3">
              <span>Product</span>
            </b-col>
            <b-col sm="9">
              <span>: {{ titleRecap }}</span>
            </b-col>
          </b-row>

          <b-row style="margin-top: 10px">
            <b-col sm="3">
              <span>Qty Order</span>
            </b-col>

            <b-col sm="9" v-if="!showRecapFlag">
              <b-form-input
                v-model="qtyOrderSales"
                type="number"
                trim
                placeholder="Input Qty"
              ></b-form-input>
              <span
                id="warning-qtyRecap"
                class="display-hidden text-small text-danger"
              >
                Required
              </span>
            </b-col>
          </b-row>

          <b-row style="margin-top: 10px">
            <b-col sm="3">
              <span>Article </span>
            </b-col>
            <b-col sm="9">
              <b-form-input
                :disabled="showRecapFlag"
                v-model="articleRecap"
                trim
                placeholder="Input Article"
              ></b-form-input>
              <span
                id="warning-articleRecap"
                class="display-hidden text-small text-danger"
              >
                Required
              </span>
            </b-col>
          </b-row>

          <b-row style="margin-top: 10px">
            <b-col sm="3">
              <span>Size</span>
            </b-col>
            <b-col sm="9">
              <v-select
                :clearable="false"
                :disabled="showRecapFlag"
                :reduce="(data) => data.code"
                v-model="sizeRecap"
                :options="optionsSizeRecap"
                placeholder="Select Size"
                label="code"
              >
              </v-select>
              <span
                id="warning-sizeRecap"
                class="display-hidden text-small text-danger"
              >
                Required
              </span>
            </b-col>
          </b-row>

          <b-row style="margin-top: 10px">
            <b-col sm="3">
              <span>Qty</span>
            </b-col>
            <b-col sm="9">
              <b-form-input
                :disabled="showRecapFlag"
                v-model="qtyRecap"
                trim
                placeholder="Input Qty"
                type="number"
              ></b-form-input>
              <span
                id="warning-qtyRecap"
                class="display-hidden text-small text-danger"
              >
                Required
              </span>
            </b-col>
          </b-row>

          <br />

          <b-row style="margin-top: 10px">
            <div style="display: contents; font-weight: 600">
              <span style="width: 30%; padding-bottom: 10px"> </span>
              <span style="width: 30%; padding-bottom: 10px"> Size </span>
              <span style="width: 30%; padding-bottom: 10px"> Qty </span>
              <span
                style="width: 10%; padding-bottom: 10px"
                @click="AddRecap()"
              >
                <b-icon
                  scale="1.5"
                  style="color: green; position: relative"
                  icon="plus-square"
                  title="add"
                ></b-icon>
              </span>
            </div>
            <br />
            <div
              v-for="(row, index) in tableRecap"
              :key="index"
              style="display: contents; margin: 0px; font-size: 11px"
            >
              <span
                v-if="row.cat != 'delete'"
                style="width: 30%; text-align: start; padding-top: 5px"
              >
                <b-icon
                  v-if="!showRecapFlag"
                  @click="deleteRowRecap(row, index)"
                  scale="1.5"
                  style="color: red; position: relative; left: 30px"
                  icon="trash-fill"
                  title="delete"
                ></b-icon>
              </span>
              <span
                v-if="row.cat != 'delete'"
                style="width: 30%; padding-top: 5px"
              >
                {{ row.size }}</span
              >
              <span
                v-if="row.cat != 'delete'"
                style="width: 30%; padding-top: 5px"
              >
                {{ row.qty }}
              </span>
            </div>
          </b-row>

          <br />

          <b-row align-h="end">
            <b-col sm="3"></b-col>
            <b-col sm="3"
              ><span> Total : {{ qtyTotalRecap }} </span></b-col
            >
            <b-col sm="3"></b-col>
            <b-col sm="3"></b-col>
          </b-row>

          <br />

          <b-row align-h="end">
            <b-col sm="3">
              <b-button
                v-if="!showRecapFlag"
                block
                size="md"
                type="button"
                variant="success"
                @click="checkRecap()"
              >
                Save
              </b-button>
            </b-col>
            <b-col sm="3">
              <b-button
                block
                size="md"
                @click="cancelRecap()"
                type="button"
                variant="warning"
              >
                Cancel
              </b-button>
            </b-col>
          </b-row>
        </div>
      </b-modal>
    </template>

    <template>
      <b-modal
        v-model="showModal"
        ok-variant="success"
        cancel-variant="warning"
        header-bg-variant="secondary"
        hide-footer
        hide-header-close
        hide-backdrop
        size="md"
        no-close-on-backdrop
        title="Data Ukur"
      >
        <div id="modal">
          <!-- Products -->
          <b-row>
            <b-col cols="12">
              <b-form-group
                label="Product *"
                label-class="text-primary"
                label-cols="3"
                label-cols-md="3"
                label-size="sm"
              >
                <v-select
                  :clearable="false"
                  v-model="itemCategory"
                  @input="InputCategory"
                  :options="optionsCategory"
                  placeholder="Select Category"
                  label="value"
                >
                </v-select>
                <span
                  id="warning-category"
                  class="display-hidden text-small text-danger"
                >
                  Required
                </span>
              </b-form-group>
              <b-form-group
                label="Product *"
                label-class="text-primary"
                label-cols="3"
                label-cols-md="3"
                label-size="sm"
              >
                <v-select
                  :clearable="false"
                  v-model="itemProducts"
                  :disabled="itemCategory == null"
                  @input="InputProduct"
                  :options="optionsProducts"
                  placeholder="Select Product"
                  label="value"
                >

                </v-select>
                <span
                  id="warning-item"
                  class="display-hidden text-small text-danger"
                >
                  Required
                </span>
              </b-form-group>
            </b-col>
          </b-row>

          <!-- Color -->
          <b-row>
            <b-col cols="12">
              <b-form-group
                label="Color *"
                label-class="text-primary"
                label-cols="3"
                label-cols-md="3"
                label-size="sm"
              >
                <v-select
                  :clearable="false"
                  v-model="itemColor"
                  @input="InputColor"
                  :options="optionsColor"
                  placeholder="Select Color"
                  label="code"
                >
                  <template v-slot:option="option">
                    {{ option.code }} - {{ option.name }}
                  </template>
                  <template slot="selected-option" slot-scope="option">
                    {{ option.code }} - {{ option.name }}
                  </template>
                </v-select>
                <span
                  id="warning-color"
                  class="display-hidden text-small text-danger"
                >
                  Required
                </span>
              </b-form-group>
            </b-col>
          </b-row>

          <!-- Intencity -->
          <b-row>
            <b-col cols="12">
              <b-form-group
                label="Intencity *"
                label-class="text-primary"
                label-cols="3"
                label-cols-md="3"
                label-size="sm"
              >
                <v-select
                  :clearable="false"
                  v-model="itemIntencity"
                  @input="InputIntencity"
                  :options="optionsIntencity"
                  placeholder="Select Intencity"
                  label="code"
                >
                  <template v-slot:option="option">
                    {{ option.code }} - {{ option.name }}
                  </template>
                  <template slot="selected-option" slot-scope="option">
                    {{ option.code }} - {{ option.name }}
                  </template>
                </v-select>
                <span
                  id="warning-intencity"
                  class="display-hidden text-small text-danger"
                >
                  Required
                </span>
              </b-form-group>
            </b-col>
          </b-row>

          <!-- Brand -->
                <b-row>
                  <b-col cols="12">
                    <b-form-group
                      label="Brand *"
                      label-class="text-primary"
                      label-cols="3"
                      label-cols-md="3"
                      label-size="sm"
                    >
                      <v-select
                        :clearable="false"
                        v-model="itemBrand"
                        @input="InputBrand"
                        :options="optionsBrand"
                        placeholder="Select Brand"
                        label="code"
                      >
                        <template v-slot:option="option">
                          {{ option.code }} - {{ option.name }}
                        </template>
                        <template slot="selected-option" slot-scope="option">
                          {{ option.code }} - {{ option.name }}
                        </template>
                      </v-select>
                      <span
                        id="warning-brand"
                        class="display-hidden text-small text-danger"
                      >
                        Required
                      </span>
                    </b-form-group>
                  </b-col>
                </b-row>

                <!-- Material -->
                <b-row>
                  <b-col cols="12">
                    <b-form-group
                      label="Material *"
                      label-class="text-primary"
                      label-cols="3"
                      label-cols-md="3"
                      label-size="sm"
                    >
                      <v-select
                        :clearable="false"
                        v-model="itemMaterial"
                        @input="InputMaterial"
                        :options="optionsMaterial"
                        placeholder="Select Material"
                        label="name"
                      >

                      </v-select>
                      <span
                        id="warning-material"
                        class="display-hidden text-small text-danger"
                      >
                        Required
                      </span>
                    </b-form-group>
                  </b-col>
                </b-row>

          <!-- Qty Product -->
          <b-row>
            <b-col cols="12">
              <b-form-group
                label="Qty *"
                label-class="text-primary"
                label-cols="3"
                label-cols-md="3"
                label-size="sm"
              >
                <b-form-input
                  v-model="form.itemQty"
                  type="number"
                  placeholder="Input Qty"
                  trim
                ></b-form-input>
                <span
                  id="warning-itemQty"
                  class="display-hidden text-small text-danger"
                >
                  Required
                </span>
              </b-form-group>
            </b-col>
          </b-row>

          <!-- Est Price -->
          <b-row>
            <b-col cols="12">
              <b-form-group
                label="Est Price *"
                label-class="text-primary"
                label-cols="3"
                label-cols-md="3"
                label-size="sm"
              >
                <b-form-input
                  v-model="itemPrice"
                  @change="ChangePrice"
                  placeholder="Input Price"
                  type="text"
                  @keypress="isNumber($event)"
                  trim
                ></b-form-input>
                <span
                  id="warning-itemPrice"
                  class="display-hidden text-small text-danger"
                >
                  Required
                </span>
              </b-form-group>
            </b-col>
          </b-row>

          <!-- Est Cogs -->
          <b-row>
            <b-col cols="12">
              <b-form-group
                label="Est Cogs *"
                label-class="text-primary"
                label-cols="3"
                label-cols-md="3"
                label-size="sm"
              >
                <b-form-input
                  v-model="itemCogs"
                  @change="ChangeCogs"
                  placeholder="Input Cogs"
                  type="text"
                  @keypress="isNumber($event)"
                  trim
                ></b-form-input>
                <span
                  id="warning-itemCogs"
                  class="display-hidden text-small text-danger"
                >
                  Required
                </span>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row align-h="end">
            <b-col sm="3">
              <b-button
                block
                size="md"
                type="button"
                variant="success"
                @click="checkProduct()"
              >
                Save
              </b-button>
            </b-col>
            <b-col sm="3">
              <b-button
                block
                size="md"
                @click="cancelProduct()"
                type="button"
                variant="warning"
              >
                Cancel
              </b-button>
            </b-col>
          </b-row>
        </div>
      </b-modal>
    </template>

    <Loader v-if="isLoadingData" fullPage useOverlay loader="spinner"></Loader>
  </div>
</template>
<script>
import Loader from "@/components/Loader/Loader";
import Vue from "vue";
import { mapActions, mapGetters, mapState } from "vuex";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
// import vue multiselect
import Multiselect from "vue-multiselect";
import apiActualActivity from "@/store/salesforce-form/actual-activity.js";
import { fnPOST } from "../../../../api/api-methods";
import { APIPATH_SALES, APIPATH_SALESFORCE } from "../../../../api/api-paths";

import Accordion from "@/components/Accordion/accordion";
import AccordionItem from "@/components/Accordion/accordion-item";

export default {
  components: {
    Multiselect,
    vSelect,
    Loader,
    Accordion,
    AccordionItem,
  },
  data() {
    const now = new Date();
    const optyear = { year: "numeric" };
    const today = now.toISOString().slice(0, 10);
    const year = now.toLocaleString("id-ID", optyear);
    return {
      isLoadingData: false,
      masks: {
        inputDateTime: "WWW DD-MMM-YYYY h:mm A",
      },
      formName: "Actual Activity Form",
      monthNames: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      dayNames: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      NowDate: today,
      today: today,
      NowYear: year,
      idData: null,
      context: null,
      totalData: 0,
      timezone: "",
      DisableActivity: true,
      hiddenReason: false,
      hiddenPOID: false,
      hiddenOptions: false,
      ButtonChange: true,
      dataActivity: [],
      optionsActivity: [],
      optionsReason: [],
      optionsSubActivity: [],
      optionsStatusCustomer: [],
      optionsProductCategory: [],
      optionsProducts: [],
      itemCategory: null,
      optionsCategory: [],
      optionsColor: [],
      optionsIntencity: [],
      optionsBrand: [],
      optionsMaterial: [],
      itemColor: null,
      itemIntencity: null,
      itemBrand: null,
      itemMaterial: null,
      SelectActivity: [],
      ProjectID: null,
      dataItemProducts: [],
      dataItemUkurProducts: [],
      itemProducts: null,
      itemPrice: null,
      itemCogs: null,
      GpValue: 0,
      revenueValue: 0,
      GpPercent: 0,
      form: {
        estShipMonth: null,
        statusCustomer: null,
        itemProducts: null,
        categoryProducts: null,
        itemPrice: null,
        itemCogs: null,
        GpValue: 0,
        GpPercent: 0,

        idSalesProjection: null,

        role: null,
        start_limit: null,
        end_limit: null,
        user_nik: null,
        username: null,

        version_app: null,

        customer_id: null,
        weekly_planning: null,
        weekly_planning_detail: null,
        customer_mapping: null,
        customer_name: null,
        po_id: null,
        actual_date: now,
        actual_time: null,
        expired_date: null,
        processed_date: today,
        activity_name: null,
        activity_id: null,
        sub_activity_name: null,
        sub_activity_id: null,
        reason: null,
        remark: null,
        coordinates: null,
        itemColor: null,
        itemColorName: null,
        itemIntencity: null,
        itemIntencityName: null,
        itemBrand: null,
        itemBrandName: null,
        itemMaterial: null,
        itemMaterialName: null,
      },
      showModal: false,
      dataProducts: [],
      editProduct: false,
      index: null,

      totalQtyRecap: 0,
      qtyOrderSales: 0,
      qtyOrderFullSales: 0,
      qtyTotalRecap: 0,
      titleRecap: null,
      partNoRecap: null,
      idRecap: null,
      tableRecap: [],
      sizeRecap: null,
      salesRecap: null,
      qtyRecap: null,
      articleRecap: null,
      colorRecap: null,
      colorNameRecap: null,
      intencityRecap: null,
      intencityNameRecap: null,
      showRecap: false,
      showRecapFlag: false,
      flagUkur: false,

      optionsSizeRecap: [],

      dataRecapMeasurement: [],

      optionsBoxType: [],
      optionsRuleType: ['normal','size'],
      boxType: [],
      ruleType: [],

      dataUploadMeasurement: [{
        item:[],
      }],

      uploadFail: false,
      fileUploadMea: null,

      lockSalesProjection: false,
      lockMeasurementRecap: false,

      dataErrorUpload: [{
        item:[],
      }],
      showDetailBox: false,

      dataDetailTable: [],
      detailArticle: null,
      detailCategory: null,
      detailItem: null,
      lockSPKPO: false,
      dataPartNo:0,
    };
  },
  computed: {
    ...mapGetters("session", ["userData"]),
    ...mapState("sales_force", [
      "stDtActActv",
      "stDtActActvCount",
      "stMstSubAct",
      "stMstSubActCount",
      "stRsn",
      "stRsnCount",
    ]),
  },
  methods: {
    ...mapActions("session", ["showNotification"]),
    ...mapActions("sales_force", [
      "GetDataActualActv",
      "getReasonActivity",
      "GetListSubActivity",
    ]),
    setData() {
      let roles = this.userData.roles;
      if (roles.length > 0) {
        for (let data in roles) {
          if (roles[data].app == "SFC") {
            let lower = roles[data].role_list.map((string) => {
              return string.toLowerCase();
            });
            this.roles_list = lower;
          }
        }
      }
      this.idData = this.$route.params.idData;
      this.form.user_nik = this.userData.nik;
      this.form.username = this.userData.fullname;

      let MinDate = new Date(this.NowDate);
      let result = MinDate.setDate(MinDate.getDate() - 1);
      this.NowDate = new Date(result).toISOString().slice(0, 10);

      let expired_date = new Date(this.today);
      let resultExpired = expired_date.setMonth(expired_date.getMonth() + 1);
      this.form.expired_date = new Date(resultExpired)
        .toISOString()
        .slice(0, 10);
      if (this.idData == null || this.idData == undefined) {
        this.showNotification({
          type: "error",
          message:
            "Problem occurred in the system. Please try again. If the problem persists, contact your system Administrator",
        });
        this.$router.push({ name: "SFCActualActivity" });
      }
      this.LoadData();
    },

    isNumber: function (evt) {
      if (!/^[0-9]+$/.test(evt.key) || evt.key === ".")
        return evt.preventDefault();
      if (evt.keyCode === 46) {
        evt.preventDefault();
      }
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    removeItem(index) {
      let Boxtrue = "";
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to remove ? ", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          Boxtrue = value;
          if (Boxtrue == true) {
            if (this.dataItemProducts[index].type == "create") {
              this.dataItemProducts.splice(index, 1);
            } else {
              this.dataItemProducts[index].type = "delete";
            }
            this.calculateGP();
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
    deletePartRecap(no, pid) {
      let Boxtrue = "";
      this.$bvModal
        .msgBoxConfirm(
          "Please confirm that you want to delete partial " + no + " ? ",
          {
            title: "Please Confirm",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          Boxtrue = value;
          if (Boxtrue == true) {
            this.delPartUkur(no, pid);
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
    addPartRecap() {
      let no = 1;
      if (this.dataItemUkurProducts) {
        no = this.dataItemUkurProducts.length + 1;
      }
      let Boxtrue = "";
      this.$bvModal
        .msgBoxConfirm(
          "Please confirm that you want to add partial " + no + " ? ",
          {
            title: "Please Confirm",
            size: "sm",
            buttonSize: "sm",
            okVariant: "success",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          Boxtrue = value;
          if (Boxtrue == true) {
            this.addPartUkur(no);
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },

    getAllListItem(part) {
      this.isLoadingData = true;
      fnPOST(APIPATH_SALESFORCE.getListItem, {
        project_id: this.ProjectID,
      })
        .then((rsp) => {
          this.isLoadingData = false;
          let data = rsp.data.payload;
          let post = false;
          if (data) {
            this.dataItemUkurProducts.forEach((val) => {
              let total = 0;
              if (val.part_no == part) {
                data.forEach((ldata) => {
                  console.log(ldata);
                  let article = "-";
                  if (ldata.qty_left == null) {
                    ldata.qty_left = ldata.qty;
                  }
                  if (ldata.qty_left > 0) {
                    let qty = ldata.qty_left;

                    if (ldata.article) {
                      article = ldata.article;
                    }
                    total = total + ldata.qty;
                    // val.total = total
                    let foundItem = val.item.find(
                      (val) => val.projection_id === ldata.id
                    );
                    if (!foundItem) {
                      post = true;

                      val.item.push({
                        projection_id: ldata.id,
                        project_id: this.ProjectID,
                        part_no: val.part_no,
                        article: article,
                        category: ldata.category,
                        item: ldata.item,
                        color: ldata.color,
                        color_name: ldata.color_name,
                        intencity: ldata.intencity,
                        intencity_name: ldata.intencity_name,
                        qty: qty,
                        qty_full: total,
                      });
                    }
                  }
                });
              }
            });
            this.dataItemUkurProducts.forEach((val) => {
              let total = 0;
              if (val.part_no == part) {
                val.item.forEach((ldata) => {
                  total = total + parseInt(ldata.qty);
                  val.total = total;
                });
              }
            });
            if (post) {
              this.postPartList();
            }
            this.loadPartUkur()
          }
        })
        .catch((err) => {
          this.isLoadingData = false;
          this.showNotification({ type: "error", message: err });
        });
    },

    postPartList() {
      this.isLoadingData = true;
      fnPOST(APIPATH_SALESFORCE.postListPartData, {
        project_id: this.ProjectID,
        updated_by: this.form.user_nik,
        updated_by_name: this.form.username,
        table: this.dataItemUkurProducts,
      })
        .then((rsp) => {
          this.isLoadingData = false;
          this.loadPartUkur();
        })
        .catch((err) => {
          this.isLoadingData = false;
          this.showNotification({ type: "error", message: err });
        });
    },

    delPartUkur(no, pid) {
      this.isLoadingData = true;
      fnPOST(APIPATH_SALESFORCE.delPartDataUkur, {
        id: pid,
        part_no: no,
        project_id: this.ProjectID,
        updated_by: this.form.user_nik,
        updated_by_name: this.form.username,
      })
        .then((rsp) => {
          this.isLoadingData = false;
          this.loadPartUkur();
        })
        .catch((err) => {
          this.isLoadingData = false;
          this.showNotification({ type: "error", message: err });
        });
    },

    addPartUkur(no) {
      this.isLoadingData = true;
      fnPOST(APIPATH_SALESFORCE.postPartDataUkur, {
        part_no: no,
        project_id: this.ProjectID,
        updated_by: this.form.user_nik,
        updated_by_name: this.form.username,
      })
        .then((rsp) => {
          this.isLoadingData = false;
          this.loadPartUkur();
        })
        .catch((err) => {
          this.isLoadingData = false;
          this.showNotification({ type: "error", message: err });
        });
    },
    loadPartUkur() {
      this.dataUploadMeasurement = []
      this.dataItemUkurProducts = [];
      this.isLoadingData = true;
      fnPOST(APIPATH_SALESFORCE.GetPartDataUkur, {
        project_id: this.ProjectID,
      })
        .then((rsp) => {
          this.isLoadingData = false;
          let data = rsp.data.payload;
          if (data) {
            data.forEach((val) => {
              this.dataItemUkurProducts.push({
                id: val.id,
                part_no: val.part_no,
                total_qty: 0,
                item: [],
              });

              if (this.dataErrorUpload.length != data.length) {
                this.dataErrorUpload.push({
                  item:[],
                })
              }

                this.dataUploadMeasurement.push({
                  item:[],
                })
            });
            this.loadPartItem();
          }
        })
        .catch((err) => {
          this.isLoadingData = false;
          this.showNotification({ type: "error", message: err });
        });
    },

    loadPartItem() {
      this.isLoadingData = true;
      fnPOST(APIPATH_SALESFORCE.getPartItem, {
        project_id: this.ProjectID,
      })
        .then((rsp) => {
          this.isLoadingData = false;
          let data = rsp.data.payload;
          if (data) {
            this.dataItemUkurProducts.forEach((val) => {
              let total = 0;
              data.forEach((ldata) => {
                if (val.part_no == ldata.part_no) {
                  total = total + parseInt(ldata.qty);
                  val.total = total;
                  if (val.part_no == ldata.part_no) {
                    val.item.push({
                      id: ldata.id,
                      projection_id: ldata.sales_projection_detail,
                      project_id: this.ProjectID,
                      part_no: ldata.part_no,
                      article: ldata.article,
                      category: ldata.category,
                      item: ldata.item,
                      color: ldata.color,
                      color_name: ldata.color_name,
                      intencity: ldata.intencity,
                      intencity_name: ldata.intencity_name,
                      qty: ldata.qty,
                      qty_full: ldata.qty,
                    });
                  }
                }
              });
            });
            this.loadRecapTotal();
            this.loadDataBox();
          }
        })

        .catch((err) => {
          this.isLoadingData = false;
          this.showNotification({ type: "error", message: err });
        });
    },
    editItem(value, index) {
      this.showModal = true;
      this.itemProducts =  value.item;
      this.itemCategory =  value.category;
      this.form.itemProducts = value.item;
      this.form.categoryProducts = value.category;
      this.form.itemQty = value.qty;
      this.itemPrice = value.est_item_price;
      this.form.itemPrice = value.est_item_price;
      this.itemCogs = value.est_cogs;
      this.form.itemCogs = value.est_cogs;
      this.editProduct = true;
      this.index = index;
      this.itemColor = value.color + "-" + value.color_name;
      this.form.itemColor = value.color;
      this.form.itemColorName = value.color_name;
      this.itemIntencity = value.intencity + "-" + value.intencity_name;
      this.form.itemIntencity = value.intencity;
      this.form.itemIntencityName = value.intencity_name;
      this.itemBrand = value.brand + "-" + value.brand_name;
      this.form.itemBrand = value.brand;
      this.form.itemBrandName = value.brand_name;
      this.itemMaterial = value.material + "-" + value.material_name;
      this.form.itemMaterial = value.material;
      this.form.itemMaterialName = value.material_name;
    },
    AddItem() {
      this.showModal = true;
      this.itemProducts = null;
      this.itemCategory =  null
      this.form.itemProducts = null;
      this.form.categoryProducts = null;
      this.form.itemQty = null;
      this.itemPrice = null;
      this.form.itemPrice = null;
      this.itemCogs = null;
      this.form.itemCogs = null;
      this.editProduct = false;
      this.index = null;
      this.itemColor = null;
      this.form.itemColor = null;
      this.form.itemColorName = null;
      this.itemIntencity = null;
      this.form.itemIntencity = null;
      this.form.itemIntencityName = null;
      this.itemBrand = null;
      this.form.itemBrand = null;
      this.form.itemBrandName = null;
      this.itemMaterial = null;
      this.form.itemMaterial = null;
      this.form.itemMaterialName = null;
    },
    cancelProduct() {
      this.showModal = false;
      this.itemProducts = null;
      this.itemCategory = null;
      this.form.itemProducts = null;
      this.form.categoryProducts = null;
      this.form.itemQty = null;
      this.itemPrice = null;
      this.form.itemPrice = null;
      this.itemCogs = null;
      this.form.itemCogs = null;
      this.editProduct = false;
      this.index = null;
      this.itemColor = null;
      this.form.itemColor = null;
      this.form.itemColorName = null;
      this.itemIntencity = null;
      this.form.itemIntencity = null;
      this.form.itemIntencityName = null;
      this.itemBrand = null;
      this.form.itemBrand = null;
      this.form.itemBrandName = null;
      this.itemMaterial = null;
      this.form.itemMaterial = null;
      this.form.itemMaterialName = null;
    },
    checkProduct() {
      if (
        this.form.itemProducts == null ||
        this.form.itemProducts == "" ||
        this.form.itemProducts.substring(0, 1) == " "
      ) {
        document
          .getElementById("warning-item")
          .classList.remove("display-hidden");
        setTimeout(() => {
          document
            .getElementById("warning-item")
            .classList.add("display-hidden");
        }, 5000);
        return false;
      }
      if (
        this.form.itemColor == null ||
        this.form.itemColor == "" ||
        this.form.itemColor.substring(0, 1) == " "
      ) {
        document
          .getElementById("warning-color")
          .classList.remove("display-hidden");
        setTimeout(() => {
          document
            .getElementById("warning-color")
            .classList.add("display-hidden");
        }, 5000);
        return false;
      }
      if (
        this.form.itemIntencity == null ||
        this.form.itemIntencity == "" ||
        this.form.itemIntencity.substring(0, 1) == " "
      ) {
        document
          .getElementById("warning-intencity")
          .classList.remove("display-hidden");
        setTimeout(() => {
          document
            .getElementById("warning-intencity")
            .classList.add("display-hidden");
        }, 5000);
        return false;
      }
      if (
        this.form.itemBrand == null ||
        this.form.itemBrand == "" ||
        this.form.itemBrand.substring(0, 1) == " "
      ) {
        document
          .getElementById("warning-brand")
          .classList.remove("display-hidden");
        setTimeout(() => {
          document
            .getElementById("warning-brand")
            .classList.add("display-hidden");
        }, 5000);
        return false;
      }
      if (
        this.form.itemMaterial == null ||
        this.form.itemMaterial == "" ||
        this.form.itemMaterial.substring(0, 1) == " "
      ) {
        document
          .getElementById("warning-material")
          .classList.remove("display-hidden");
        setTimeout(() => {
          document
            .getElementById("warning-material")
            .classList.add("display-hidden");
        }, 5000);
        return false;
      }
      if (
        this.form.itemQty == null ||
        this.form.itemQty == "" ||
        this.form.itemQty == isNaN
      ) {
        document
          .getElementById("warning-itemQty")
          .classList.remove("display-hidden");
        setTimeout(() => {
          document
            .getElementById("warning-itemQty")
            .classList.add("display-hidden");
        }, 5000);
        return false;
      }
      if (
        this.form.itemPrice == null ||
        this.form.itemPrice == "" ||
        this.form.itemPrice == isNaN
      ) {
        document
          .getElementById("warning-itemPrice")
          .classList.remove("display-hidden");
        setTimeout(() => {
          document
            .getElementById("warning-itemPrice")
            .classList.add("display-hidden");
        }, 5000);
        return false;
      }
      if (
        this.form.itemCogs == null ||
        this.form.itemCogs == "" ||
        this.form.itemCogs == isNaN
      ) {
        document
          .getElementById("warning-itemCogs")
          .classList.remove("display-hidden");
        setTimeout(() => {
          document
            .getElementById("warning-itemCogs")
            .classList.add("display-hidden");
        }, 5000);
        return false;
      }
      // console.log(this.form.itemCogs)
      // console.log(this.form.itemPrice)
      if (this.form.itemCogs >= this.form.itemPrice) {
        this.showNotification({
          type: "info",
          message: "Est Cogs more than Est Price",
        });
        return false;
      }
      if (this.editProduct) {
        this.editDataProduct(this.index);
      } else {
        this.submitProduct();
      }
    },
    submitProduct() {
      let data = {
        item: this.form.itemProducts,
        category: this.form.categoryProducts,
        color: this.form.itemColor,
        color_name: this.form.itemColorName,
        intencity: this.form.itemIntencity,
        intencity_name: this.form.itemIntencityName,
        brand: this.form.itemBrand,
        brand_name: this.form.itemBrandName,
        material: this.form.itemMaterial,
        material_name: this.form.itemMaterialName,
        qty: this.form.itemQty,
        est_item_price: this.form.itemPrice,
        est_cogs: this.form.itemCogs,
        type: "create",
      };
      this.dataItemProducts.push(data);
      // console.log(this.dataItemProducts)
      this.cancelProduct();
      this.calculateGP();
    },
    editDataProduct(index) {
      // console.log(index)
      // console.log(this.dataItemProducts)
      // console.log(this.form.itemProducts)
      this.dataItemProducts[index].item = this.form.itemProducts;
      this.dataItemProducts[index].category = this.form.categoryProducts;
      this.dataItemProducts[index].qty = this.form.itemQty;
      this.dataItemProducts[index].est_item_price = this.form.itemPrice;
      this.dataItemProducts[index].est_cogs = this.form.itemCogs;
      this.dataItemProducts[index].color = this.form.itemColor;
      this.dataItemProducts[index].color_name = this.form.itemColorName;
      this.dataItemProducts[index].intencity = this.form.itemIntencity;
      this.dataItemProducts[index].intencity_name = this.form.itemIntencityName;
      this.dataItemProducts[index].brand  = this.form.itemBrand;
      this.dataItemProducts[index].brand_name = this.form.itemBrandName;
      this.dataItemProducts[index].material = this.form.itemMaterial;
      this.dataItemProducts[index].material_name = this.form.itemMaterialName;
      if (this.dataItemProducts[index].type != "create") {
        this.dataItemProducts[index].type = "update";
      }

      // console.log(this.dataItemProducts)
      this.cancelProduct();
      this.calculateGP();
    },
    InputCategory() {
      if (this.itemCategory) {
        this.optionsProducts = [];
        this.optionsProductCategory.forEach(val => {
          if (this.itemCategory == val.category) {
            this.optionsProducts.push(val);
          }
        });
        this.form.categoryProducts = this.itemCategory;
        this.form.itemProducts = null;
        this.itemProducts = null
      }
    },
    InputProduct() {
      // console.log(this.itemProducts)
      if (this.itemProducts) {
        this.form.itemProducts = this.itemProducts.value;
        // console.log(this.form.itemProducts)
        // console.log(this.form.categoryProducts)
      }
    },
    InputColor() {
      if (this.itemColor) {
        this.form.itemColor = this.itemColor.code;
        this.form.itemColorName = this.itemColor.name;
      }
    },
    InputIntencity() {
      if (this.itemIntencity) {
        this.form.itemIntencity = this.itemIntencity.code;
        this.form.itemIntencityName = this.itemIntencity.name;
      }
    },
    InputBrand() {
      if (this.itemBrand) {
        this.form.itemBrand = this.itemBrand.code;
        this.form.itemBrandName = this.itemBrand.name;
      }
    },
    InputMaterial() {
      if (this.itemMaterial) {
        this.form.itemMaterial = this.itemMaterial.code;
        this.form.itemMaterialName = this.itemMaterial.name;
      }
    },

    ChangePrice() {
      if (this.itemPrice) {
        this.form.itemPrice = parseFloat(this.itemPrice);
        this.itemPrice = parseFloat(this.itemPrice);
        // .toString()
        // .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
      }
      // console.log(this.form.itemPrice)
      // console.log(this.itemPrice)
    },
    ChangeCogs() {
      if (this.itemCogs) {
        this.form.itemCogs = parseFloat(this.itemCogs);
        this.itemCogs = parseFloat(this.itemCogs);
        // .toString()
        // .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
      }
      // console.log(this.form.itemCogs)
      // console.log(this.itemCogs)
    },
    calculateGP() {
      let gp_value = 0;
      let gp_percent = 0;
      let revenue = 0;
      let total_price = 0;
      let total_cogs = 0;
      if (this.dataItemProducts) {
        for (let a = 0; a < this.dataItemProducts.length; a++) {
          // console.log(this.dataItemProducts[a].qty)
          // console.log(this.dataItemProducts[a].est_item_price)
          // console.log(this.dataItemProducts[a].est_cogs)
          if (this.dataItemProducts[a].type != "delete") {
            gp_value +=
              this.dataItemProducts[a].qty *
              (this.dataItemProducts[a].est_item_price -
                this.dataItemProducts[a].est_cogs);
            total_price +=
              this.dataItemProducts[a].est_item_price *
              this.dataItemProducts[a].qty;
            total_cogs +=
              this.dataItemProducts[a].est_cogs * this.dataItemProducts[a].qty;
            gp_percent = (gp_value / total_price) * 100;
            revenue = total_price;
          }
        }
      }
      this.revenueValue = revenue
        .toFixed(2)
        .toString()
        .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
      this.form.GpValue = gp_value;
      this.form.GpPercent = gp_percent.toFixed(2);
      this.GpValue = gp_value
        .toFixed(2)
        .toString()
        .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
      this.GpPercent = gp_percent
        .toFixed(2)
        .toString()
        .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");

      // this.loadRecapTotal();
    },

    LoadData() {
      this.dataActivity = [];

      // start loading
      this.isLoadingData = true;

      this.GetDataActualActv({
        id: this.idData,
      })
        .then((rsp) => {
          // console.log(rsp)
          this.dataActivity = this.stDtActActv;
          if (
            this.stDtActActvCount == 0 ||
            this.stDtActActvCount == undefined
          ) {
            this.dataActivity = rsp.data.payload[0];
          }
          this.ProjectID = rsp.data.payload[0].project_id;
          this.lockSPKPO = rsp.data.payload[0].spk_po;
          this.getReasonActivity({
            filter: "filter",
            id: this.dataActivity[0].customer,
            project_id: this.ProjectID,
          }).then((rsp) => {
            this.optionsActivity = rsp.payload;
            this.SetDataForm();
            this.loadPartUkur();
          });
        })
        .catch((err) => {
          this.showNotification({ type: "error", message: err });
        })
        .finally(() => {
          // stop loading
          setTimeout(() => {
            this.isLoadingData = false;
          }, 500);
        });

      fnPOST(APIPATH_SALESFORCE.masterStatusCustomer, {})
        .then((rsp) => {
          if (rsp.data.payload) {
            this.optionsStatusCustomer = rsp.data.payload;
          }
        })
        .catch((err) => {
          this.showNotification({ type: "error", message: err });
        });

      fnPOST(APIPATH_SALESFORCE.masterProductCategory, {})
        .then((rsp) => {
          if (rsp.data.payload) {
            this.optionsProductCategory = rsp.data.payload;
            this.optionsProductCategory.forEach(val => {
              if (!this.optionsCategory.includes(val.category)) {
                this.optionsCategory.push(val.category);
              }
            });
          this.optionsProducts = rsp.data.payload;
        }
        })
        .catch((err) => {
          this.showNotification({ type: "error", message: err });
        });
      fnPOST(APIPATH_SALESFORCE.masterColor, {}).then((rsp) => {
        if (rsp.data.payload) {
          this.optionsColor = rsp.data.payload;
        }
      });
      fnPOST(APIPATH_SALESFORCE.masterIntencity, {}).then((rsp) => {
        if (rsp.data.payload) {
          this.optionsIntencity = rsp.data.payload;
        }
      });
      fnPOST(APIPATH_SALESFORCE.masterBrand, {}).then((rsp) => {
        if (rsp.data.payload) {
          this.optionsBrand = rsp.data.payload;
        }
      });
      fnPOST(APIPATH_SALESFORCE.masterMaterial, {}).then((rsp) => {
        if (rsp.data.payload) {
          this.optionsMaterial = rsp.data.payload;
        }
      });
    },
    changeActivity() {
      this.DisableActivity = false;
      this.ButtonChange = false;
    },
    SetDataForm() {
      let dataForm = this.dataActivity[0];
      this.form.customer_name = dataForm.customer_name;
      this.form.customer_id = dataForm.customer;
      if (dataForm.allowed_phase) {
        if (
          dataForm.allowed_phase == "Initial" ||
          dataForm.allowed_phase == "Progress"
        ) {
          this.hiddenPOID = false;
        } else {
          this.hiddenPOID = true;
        }
      }
      this.form.po_id = dataForm.po_id;
      this.form.activity_name = dataForm.activity_name;
      for (let a = 0; a <= this.optionsActivity.length - 1; a++) {
        if (this.form.activity_name == this.optionsActivity[a].name) {
          this.SelectActivity = this.optionsActivity[a];
        }
      }
      // this.form.sub_activity_name = dataForm.sub_activity_name
      // this.form.remark = dataForm.remark
      // this.form.reason = dataForm.reason
      this.form.customer_mapping = dataForm.customer_mapping;
      this.form.weekly_planning_detail = dataForm.weekly_planning_detail;
      this.form.weekly_planning = dataForm.weekly_planning;
      this.LoadActivity();
      this.loadSalesProjection();
    },
    onContext(ctx) {
      this.context = ctx;
    },
    InputSubActivity() {
      this.hiddenReason = false;
      this.optionsReason = [];
      this.form.reason = null;
      this.getReasonActivity({
        activity: this.form.sub_activity_name,
      })
        .then((res) => {
          if (res != "No Data") {
            this.optionsReason = res.payload;
            if (this.optionsReason.length > 0) {
              this.hiddenReason = true;
            } else {
              this.hiddenReason = false;
            }
          }
        })
        .catch((err) => {
          this.showNotification({ type: "error", message: err });
        });
    },
    InputActivity(value) {
      this.hiddenOptions = false;
      this.hiddenReason = false;
      let inputValue = [];
      value.forEach((value) => {
        inputValue.push(value.name);
      });
      this.form.activity_name = inputValue;
      this.form.reason = null;
      this.form.sub_activity_name = null;
      this.optionsSubActivity = [];
      this.optionsReason = [];
      this.LoadActivity();
    },
    loadSalesProjection() {
      this.revenueValue = 0;
      this.isLoadingData = true;
      fnPOST(APIPATH_SALESFORCE.getSalesProjection, {
        project_id: this.ProjectID,
        customer_id: this.form.customer_id,
      })
        .then((rsp) => {
          this.isLoadingData = false;
          if (rsp.data.payload) {
            let data = rsp.data.payload;
            if (data.length > 0) {
              this.form.idSalesProjection = data[0].id;
              this.form.estShipMonth = data[0].est_shipment_month.substring(
                0,
                7
              );
              // console.log(this.form.estShipMonth)
              this.form.statusCustomer = data[0].status_customer;
              this.form.GpValue = data[0].gp_value;
              this.form.GpPercent = data[0].gp_percent;
              let gpValue = parseFloat(data[0].gp_value);
              let gpPercent = parseFloat(data[0].gp_percent);
              this.GpValue = gpValue
                .toFixed(2)
                .toString()
                .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
              this.GpPercent = gpPercent
                .toFixed(2)
                .toString()
                .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
              this.loadSalesProjectionDetail();
            }
          }
        })
        .catch((err) => {
          this.isLoadingData = false;
          this.showNotification({ type: "error", message: err });
        });
    },
    loadSalesProjectionDetail() {
      this.isLoadingData = true;
      fnPOST(APIPATH_SALESFORCE.getSalesProjectionDetail, {
        sales_projection: this.form.idSalesProjection,
      })
        .then((rsp) => {
          this.isLoadingData = false;
          // console.log(rsp)
          // let dataDetail = rsp.data.payload;
          this.dataItemProducts = rsp.data.payload;
          let revenue = 0;
          for (let a = 0; a < this.dataItemProducts.length; a++) {
            revenue +=
              this.dataItemProducts[a].est_item_price *
              this.dataItemProducts[a].qty;
          }
          if (revenue > 0) {
            this.revenueValue = revenue
              .toFixed(2)
              .toString()
              .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
          }
          // this.loadRecapTotal();
        })
        .catch((err) => {
          this.isLoadingData = false;
          this.showNotification({ type: "error", message: err });
        });
    },

    loadSizeRecap() {
      fnPOST(APIPATH_SALESFORCE.masterSize, {})
        .then((rsp) => {
          if (rsp.data.payload) {
            this.optionsSizeRecap = rsp.data.payload;
          }
        })
        .catch((err) => {
          this.showNotification({ type: "error", message: err });
        });
    },

    deleteRowRecap(row, index) {
      this.tableRecap.splice(index, 1);
      this.qtyTotalRecap = this.qtyTotalRecap - parseInt(row.qty);
    },

    checkRecap() {
      let submit = true;
      // if (this.articleRecap == null || this.articleRecap == '' || this.articleRecap.substring(0, 1) == ' ') {
      //   document
      //     .getElementById("warning-articleRecap")
      //     .classList.remove("display-hidden");
      //   setTimeout(() => {
      //     document
      //       .getElementById("warning-articleRecap")
      //       .classList.add("display-hidden");
      //   }, 5000);
      //   return false;
      // }

      if (
        this.articleRecap == null ||
        this.articleRecap == "" ||
        this.articleRecap == "-" ||
        this.articleRecap.substring(0, 1) == " "
      ) {
        this.articleRecap = "-";
      } else {
        if (this.articleRecap.length <= 8) {
          this.showNotification({
            type: "info",
            message: "The length of the article code is not appropriate",
          });
          return false;
        }

        this.articleRecap = this.articleRecap.toUpperCase();

        if (this.articleRecap.slice(9, 10) != this.colorRecap) {
          this.showNotification({
            type: "info",
            message: "The Code Color on the article code not same",
          });
          return false;
        }
        if (this.articleRecap.slice(10, 11) != this.intencityRecap) {
          this.showNotification({
            type: "info",
            message: "The Code Intencity on the article code not same",
          });
          return false;
        }
      }

      if (this.tableRecap) {
        if (!this.tableRecap.length > 0) {
          this.showNotification({
            type: "info",
            message: "Table still empty",
          });
          submit = false;
          return false;
        }
      }
      if (this.qtyOrderSales != this.qtyTotalRecap) {
        this.showNotification({
          type: "info",
          message: "The qty not same",
        });
        submit = false;
        return false;
      }

      console.log(this.dataItemProducts);
      let totalItem = 0;
      let totalEditItem = 0;
      let totalRecap = 0;
      let part_no = 0;
      this.dataItemProducts.forEach((el) => {
        if (el.id == this.salesRecap) {
          totalItem = el.qty;
        }
      });
      this.tableRecap.forEach((e) => {
        part_no = e.part_no;
        totalRecap = totalRecap + parseInt(e.qty);
      });
      this.dataItemUkurProducts.forEach((val) => {
        val.item.forEach((dat) => {
          if (dat.projection_id == this.salesRecap) {
            if (part_no == dat.part_no) {
              totalEditItem = totalEditItem + parseInt(this.qtyOrderSales);
            } else {
              totalEditItem = totalEditItem + parseInt(dat.qty);
            }
          }
        });
      });
      // console.log(this.tableRecap)
      // console.log(this.dataItemUkurProducts)
      // console.log(totalEditItem)
      // console.log(totalItem)

      if (totalItem < totalEditItem) {
        this.showNotification({
          type: "info",
          message: "The qty is already more than max",
        });
        submit = false;
        return false;
      }
      if (submit) {
        this.submitRecapDetail();
      }
    },

    submitRecapDetail() {
      this.isLoadingData = true;
      fnPOST(APIPATH_SALESFORCE.postDataUkur, {
        id: this.idRecap,
        project_id: this.ProjectID,
        user_nik: this.form.user_nik,
        user_name: this.form.username,
        article: this.articleRecap,
        total: this.qtyOrderSales,
        sales_projection_detail: this.salesRecap,
        table: this.tableRecap,
      })
        .then((rsp) => {
          this.showRecap = true;
          this.isLoadingData = false;
          // console.log(rsp)
          this.showNotification({
            type: "success",
            message: "Successfully Submitted",
          });
          this.showRecap = false;
          // this.loadSalesProjectionDetail();
          this.loadPartUkur();
          // this.cancelRecap();
        })
        .catch((err) => {
          this.isLoadingData = false;
          this.showNotification({ type: "error", message: err });
        });
    },

    AddRecap() {
      this.qtyTotalRecap = 0;
      let add = true;
      let qty = 0;
      if (this.tableRecap) {
        if (this.tableRecap.length > 0) {
          this.tableRecap.forEach((val) => {
            if (qty == 0) {
              qty = parseInt(val.qty);
            } else {
              qty += parseInt(val.qty);
            }
            if (this.sizeRecap == val.size) {
              this.showNotification({
                type: "info",
                message: "This size is already exist",
              });
              add = false;
              return false;
            }
          });
        }
        this.qtyTotalRecap = qty;
      }

      if (
        this.sizeRecap == null ||
        this.sizeRecap == "" ||
        this.sizeRecap.substring(0, 1) == " "
      ) {
        document
          .getElementById("warning-sizeRecap")
          .classList.remove("display-hidden");
        setTimeout(() => {
          document
            .getElementById("warning-sizeRecap")
            .classList.add("display-hidden");
        }, 5000);
        add = false;
        return false;
      }
      if (this.qtyRecap == null || !this.qtyRecap > 0) {
        document
          .getElementById("warning-qtyRecap")
          .classList.remove("display-hidden");
        setTimeout(() => {
          document
            .getElementById("warning-qtyRecap")
            .classList.add("display-hidden");
        }, 5000);
        add = false;
        return false;
      }
      if (add) {
        if (parseInt(qty) + parseInt(this.qtyRecap) > this.qtyOrderSales) {
          this.showNotification({
            type: "info",
            message: "The quantity size has exceeded the order quantity",
          });
          add = false;
          return false;
        } else {
          this.qtyTotalRecap = parseInt(this.qtyRecap) + this.qtyTotalRecap;
        }
      }
      let data = {
        sales_projection_detail: this.salesRecap,
        part_no: this.partNoRecap,
        size: this.sizeRecap,
        color: this.colorRecap,
        color_name: this.colorNameRecap,
        intencity: this.intencityRecap,
        intencity_name: this.intencityNameRecap,
        qty: this.qtyRecap,
        cat: "create",
      };
      if (add) {
        this.tableRecap.push(data);
      }
    },

    cancelDetail() {
      this.showDetailBox = false;
    },
    loadDetailBox(row) {
      this.isLoadingData = true;
      fnPOST(APIPATH_SALESFORCE.dataUploadDataboxDetail, {
        project_id: row.project_id,
        article: row.article,
      })
        .then((rsp) => {
          this.isLoadingData = false;
          this.detailArticle = row.article;
          // this.detailNik = rsp.data.payload[0].nik;
          this.detailCategory = row.category;
          this.detailItem = row.item;
          // this.detailPosition = rsp.data.payload[0].position;
          // this.detailAddress = rsp.data.payload[0].address;
          // this.detailGender = rsp.data.payload[0].gender;
          this.dataDetailTable = rsp.data.payload;
          this.showDetailBox = true;
          // console.log(rsp)
        })
        .catch((err) => {
          this.isLoadingData = false;
          this.showNotification({ type: "error", message: err });
        })
        .finally(() => {
          this.isLoadingData = false;
        });
    },

    cancelRecap() {
      this.showRecap = false;
      setTimeout(() => {
        this.showRecapFlag = false;
        this.qtyOrderSales = 0;
        this.titleRecap = null;
        this.sizeRecap = null;
        this.qtyRecap = null;
        this.idRecap = null;
        this.salesRecap = null;
        this.articleRecap = null;
        this.partNoRecap = null;
        this.colorRecap = null;
        this.colorNameRecap = null;
        this.intencityRecap = null;
        this.intencityNameRecap = null;
        this.tableRecap = [];
      }, 200);
    },
    deleteRecapPartDetail() {
      this.isLoadingData = true;

      fnPOST(APIPATH_SALESFORCE.delPartDataUkur, {
        id: this.idRecap,
        project_id: this.ProjectID,
      })
        .then((rsp) => {
          this.isLoadingData = false;
          this.loadRecapDetail();
        })
        .catch((err) => {
          this.isLoadingData = false;
          this.showNotification({ type: "error", message: err });
        });
    },

    deleteRecapDetail() {
      this.isLoadingData = true;
      fnPOST(APIPATH_SALESFORCE.delPartItemData, {
        id: this.idRecap,
        project_id: this.ProjectID,
        updated_by: this.form.user_nik,
        updated_by_name: this.form.username,
      })
        .then((rsp) => {
          this.isLoadingData = false;
          this.loadPartUkur();
        })
        .catch((err) => {
          this.isLoadingData = false;
          this.showNotification({ type: "error", message: err });
        });
    },
    deleteItemRecap(row) {
      console.log(row);
      this.idRecap = row.id;
      let Boxtrue = "";
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to delete Item ? ", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          Boxtrue = value;
          if (Boxtrue == true) {
            this.deleteRecapDetail();
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
    showItemRecap(row, index) {
      console.log(row);
      this.showRecapFlag = true;
      this.qtyOrderSales = row.qty;
      this.titleRecap = row.category + "-" + row.item;
      this.idRecap = row.id;
      this.articleRecap = row.article;
      this.partNoRecap = row.part_no;
      this.colorRecap = row.color;
      this.colorNameRecap = row.color_name;
      this.intencityRecap = row.intencity;
      this.salesRecap = row.projection_id;
      this.intencityNameRecap = row.intencity_name;
      this.loadRecapDetail();
    },
    editItemRecap(row) {
      console.log(row);
      this.showRecapFlag = false;
      this.qtyOrderSales = row.qty;
      this.qtyOrderFullSales = row.qty_full;
      this.titleRecap = row.category + "-" + row.item;
      this.articleRecap = row.article;
      this.partNoRecap = row.part_no;
      this.colorRecap = row.color;
      this.colorNameRecap = row.color_name;
      this.intencityRecap = row.intencity;
      this.intencityNameRecap = row.intencity_name;
      this.idRecap = row.id;
      this.salesRecap = row.projection_id;
      this.sizeRecap = null;
      this.loadRecapDetail();
    },

    loadRecapDetail() {
      this.isLoadingData = true;
      fnPOST(APIPATH_SALESFORCE.dataUkur, {
        id: this.idRecap,
      })
        .then((rsp) => {
          this.qtyTotalRecap = 0;
          this.showRecap = true;
          this.isLoadingData = false;
          // console.log(rsp)
          this.tableRecap = rsp.data.payload;
          if (this.tableRecap) {
            if (this.tableRecap.length) {
              this.tableRecap.forEach((val) => {
                this.qtyTotalRecap =
                  parseInt(this.qtyTotalRecap) + parseInt(val.qty);
              });
            }
          }
        })
        .catch((err) => {
          this.isLoadingData = false;
          this.showNotification({ type: "error", message: err });
        });
    },

    loadRecapTotal() {
      let total_qty = 0;
      if (this.dataItemUkurProducts) {
        this.dataItemUkurProducts.forEach((val) => {
          if (total_qty == 0) {
            total_qty = parseInt(val.qty);
          } else {
            total_qty += parseInt(val.qty);
          }
        });
      }
      this.totalQtyRecap = total_qty;

      if (this.dataItemUkurProducts.length > 0) {
        this.dataRecapMeasurement = [];
        this.loadMeasurementRecap();
      }
    },

    loadBoxType() {
      fnPOST(APIPATH_SALESFORCE.masterBoxType, {})
        .then((rsp) => {
          if (rsp.data.payload) {
            this.optionsBoxType = rsp.data.payload;
          }
        })
        .catch((err) => {
          this.showNotification({ type: "error", message: err });
        });
    },

    loadMeasurementRecap() {
      this.dataItemUkurProducts.forEach((val) => {
        // console.log(val);
        this.isLoadingData = true;
        fnPOST(APIPATH_SALESFORCE.dataUkur, {
          part_no: val.part_no,
          project_id: this.ProjectID,
        })
          .then((rsp) => {
            this.isLoadingData = false;
            // console.log(rsp)
            if (rsp.data.payload.length > 0) {
              this.dataRecapMeasurement.push({
                id:val.id,
                part_no: val.part_no,
                project_id: this.ProjectID,
                total: 0,
                item: [],
              });
              this.dataRecapMeasurement.forEach((dat) => {
                let total = 0;
                rsp.data.payload.forEach((tbl) => {
                  if (dat.part_no == tbl.part_no) {
                    total = total + parseInt(tbl.qty);
                    dat.total = total;
                    dat.item.push(tbl);
                  }
                });
              });
            }
            this.dataRecapMeasurement.sort((a, b) => parseInt(a.part_no) - parseInt(b.part_no));
          })
          .catch((err) => {
            this.isLoadingData = false;
            this.showNotification({ type: "error", message: err });
          });
      });
    },
    btnDownloadMeasurement() {
      let APIDomain = new URL(window.location.href);
      let APIPort = "8000";
      if (APIDomain.hostname == "localhost") {
        APIDomain.hostname = "https://testapps.bbi-apparel.com";
      }
      window.open(
        APIDomain.protocol +
          "//" +
          APIDomain.hostname +
          ":" +
          APIPort +
          "/media/sfc/Template_Measurement.xlsx",
        "_blank"
      );
    },

    btnUploadMeasurement(dat) {
      let notclick = false
      let index = -1
      this.dataItemUkurProducts.forEach(data => {
        index++
        if (dat.part_no == data.part_no) {
          if (parseInt(dat.total) != parseInt(data.total)) {
            this.showNotification({
              type: "info",
              message: "Qty recap data ukur dan upload data ukur belum sama",
            });
            notclick = true
            document
              .getElementById(`warning-qtypo${index}`)
              .classList.remove("display-hidden");
            setTimeout(() => {
              document
                .getElementById(`warning-qtypo${index}`)
                .classList.add("display-hidden");
            }, 5000);

            return false;
          }
        }
        data.item.forEach(val => {
          if (val.article == null || val.article == '-' || val.article.length < 7) {
            this.showNotification({
              type: "info",
              message: "Article Masih ada yang belum di isi",
            });
            notclick = true
            return false;
          }
        })
      })
      if (this.boxType[dat.part_no-1] == null) {
        this.showNotification({
          type: "info",
          message: "Box Type belum di pilih",
        });
        notclick = true
        return false;
      }
      if (this.ruleType[dat.part_no-1] == null) {
        this.showNotification({
          type: "info",
          message: "Rule Type belum di pilih",
        });
        notclick = true
        return false;
      }
      if (!notclick) {
        this.dataPartNo = dat.part_no
        document.getElementById("fileSizeSpec").click();
      }
    },
    unlock() {
      this.lockMeasurementRecap = false;
    },
    uploadMeasurement() {
      if (this.fileUploadMea != null) {
        this.uploadMeasurementProcess();
      }
    },
    loadDataBox() {
      this.isLoadingData = true;
      fnPOST(APIPATH_SALESFORCE.dataUploadDatabox, {
        project_id: this.ProjectID,
      })
        .then((rsp) => {
          this.isLoadingData = false;
          // console.log(rsp)
          let data = rsp.data.payload
          if (rsp.data.payload.length > 0) {
            data.forEach(val => {
              this.dataUploadMeasurement[val.part_no-1].item.push(val)
              this.boxType[val.part_no-1] = val.box_type;
              this.ruleType[val.part_no-1] = 'normal';
            })

            // this.dataUploadMeasurement = data

            // this.lockMeasurementRecap = true;
          }
        })
        .catch((err) => {
          this.isLoadingData = false;
          this.showNotification({ type: "error", message: err });
        })
        .finally(() => {
          this.isLoadingData = false;
        });
    },
    uploadMeasurementProcess() {
      const fdFile = new FormData();
      fdFile.append("upload", this.fileUploadMea);
      fdFile.append("boxtype", this.boxType[this.dataPartNo -1]);
      fdFile.append("ruletype", this.ruleType[this.dataPartNo -1]);
      fdFile.append("part_no", this.dataPartNo);
      fdFile.append("project_id", this.ProjectID);
      fdFile.append("user_nik", this.form.user_nik);
      fdFile.append("username", this.form.username);
      this.isLoadingData = true;

      fnPOST(APIPATH_SALESFORCE.postUploadDatabox, fdFile)
        .then((rsp) => {
          this.dataUploadMeasurement = [];
          this.dataErrorUpload = [];
          for (let a=0; a<this.dataItemUkurProducts.length; a++) {
            this.dataErrorUpload.push({
              item:[],
            })
            this.dataUploadMeasurement.push({
              item:[],
            })

          }
          this.loadDataBox();
          this.uploadFail = false;
          this.isLoadingData = false;
          this.fileUploadMea = null;
        })
        .catch((e) => {
          // console.log(e.response.data.message)
          this.fileUploadMea = null;
          this.isLoadingData = false;
          let msg = e.response.data.message;
          this.showNotification({
              type: "error",
              message: msg,
            });
          if (msg.includes("///")) {
            msg = msg
              .replace(/"/g, "")
              .replace(/'/g, '"')
              .replace(/None/g, "null")
              .replace("BBISFC: ", "")
              .replace("[", "")
              .replace("]", "")
              .replace("[", "")
              .replace(/\\/g, "");
            msg = msg.split(" /// ");
            let jsonMsg = JSON.parse(msg[1]);

            this.dataErrorUpload[this.dataPartNo-1].item.push({
              error: msg[0],
              name: jsonMsg.name,
              address: jsonMsg.address,
              gender: jsonMsg.gender,
              size: jsonMsg.size,
            });
            setTimeout(() => {
              this.uploadFail = true;
            }, 1000);
          } else {
            this.showNotification({
              type: "error",
              message: e.response.data.message,
            });
          }
        })
        .finally(() => {
          this.isLoadingData = false;
        });
    },
    LoadActivity() {
      this.GetListSubActivity({
        activity: this.form.activity_name,
      })
        .then((rsp) => {
          this.optionsSubActivity = rsp.data.payload;
          if (this.optionsSubActivity.length > 0) {
            this.hiddenOptions = true;
          }
        })
        .catch((err) => {
          this.showNotification({ type: "error", message: err });
        });

      this.getReasonActivity({
        activity: this.form.activity_name,
      })
        .then((res) => {
          if (res != "No Data") {
            this.optionsReason = res;
            if (this.optionsReason.length > 0) {
              this.hiddenReason = true;
            }
          }
        })
        .catch((err) => {
          this.showNotification({ type: "error", message: err });
        });
    },
    FormatDate(value) {
      if (value == null || value == undefined || value == "") {
        return " ";
      } else {
        let date = new Date(value);
        let nameDay = this.dayNames[date.getDay()];
        let day = date.getDate();
        if (String(day).length == 1) {
          day = "0" + String(day);
        }
        let year = date.getFullYear();
        let bulan = this.monthNames[date.getMonth()];
        date = nameDay + " " + day + " " + bulan + " " + year;
        return date;
      }
    },
    cancel() {
      this.$router.push({ name: "SFCActualActivity" });
    },
    Confirm(choice) {
      let varOk = "danger";
      if (choice !== "delete") {
        varOk = "success";
      }
      let Boxtrue = "";
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to " + choice + " ? ", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: varOk,
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          Boxtrue = value;
          if (Boxtrue == true) {
            this.checkSubmitRecap();
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
    checkSubmitRecap() {
      // let len = this.dataItemProducts.length;
      // let loop = 0;
      // if (this.form.activity_name.includes("Rekap Data Ukur")) {
      //   this.dataItemProducts.forEach((val) => {
      //     val.id;
      //     this.isLoadingData = true;
      //     loop++;
      //     fnPOST(APIPATH_SALESFORCE.dataUkur, {
      //       id: val.id,
      //     })
      //       .then((rsp) => {
      //         this.isLoadingData = false;
      //         // console.log(rsp)
      //         if (rsp.data.payload.length == 0) {
      //           this.showNotification({
      //             type: "info",
      //             message: "Data Measurement Recap masih ada yang belum terisi",
      //           });
      //           document
      //             .getElementById("warning-measurementRecap")
      //             .classList.remove("display-hidden");
      //           setTimeout(() => {
      //             document
      //               .getElementById("warning-measurementRecap")
      //               .classList.add("display-hidden");
      //           }, 5000);
      //           return false;
      //         }
      //         if (len == loop) {
      //           this.onSubmit();
      //         }
      //       })
      //       .catch((err) => {
      //         this.isLoadingData = false;
      //         this.showNotification({ type: "error", message: err });
      //       });
      //   });
      // } else {
      //   this.onSubmit();
      // }
      this.onSubmit();
    },
    onSubmit() {
      if ((this.form.activity_name.includes("Invoicing"))) {
        let total_sales = 0
        let total_databox = 0
        this.dataItemProducts.forEach(data => {
          console.log(data)
          total_sales += parseInt(data.qty)
        })
        this.dataUploadMeasurement.forEach(val => {
            console.log(val)
            val.item.forEach(dt=> {
            console.log(dt)
            total_databox += parseInt(dt.total)
          })

        })
        // if (total_sales != total_databox) {
        //   this.showNotification({
        //     type: "info",
        //     message: "Total Upload dan Total Sales Projection tidak sama",
        //   });
        //   return false;
        // }

      }
      if (
        this.form.estShipMonth == null ||
        this.form.estShipMonth == "" ||
        this.form.estShipMonth == undefined
      ) {
        document
          .getElementById("warning-shipment")
          .classList.remove("display-hidden");
        document
          .getElementById("warning-sales_projection")
          .classList.remove("display-hidden");
        setTimeout(() => {
          document
            .getElementById("warning-shipment")
            .classList.add("display-hidden");
          document
            .getElementById("warning-sales_projection")
            .classList.add("display-hidden");
        }, 5000);
        return false;
      }
      if (
        this.form.statusCustomer == null ||
        this.form.statusCustomer == "" ||
        this.form.statusCustomer == undefined
      ) {
        document
          .getElementById("warning-projectStatus")
          .classList.remove("display-hidden");
        document
          .getElementById("warning-sales_projection")
          .classList.remove("display-hidden");
        setTimeout(() => {
          document
            .getElementById("warning-projectStatus")
            .classList.add("display-hidden");
          document
            .getElementById("warning-sales_projection")
            .classList.add("display-hidden");
        }, 5000);
        return false;
      }
      if (
        this.dataItemProducts == null ||
        this.dataItemProducts == "" ||
        this.dataItemProducts.length == undefined
      ) {
        document
          .getElementById("warning-products")
          .classList.remove("display-hidden");
        document
          .getElementById("warning-sales_projection")
          .classList.remove("display-hidden");
        setTimeout(() => {
          document
            .getElementById("warning-products")
            .classList.add("display-hidden");
          document
            .getElementById("warning-sales_projection")
            .classList.add("display-hidden");
        }, 5000);
        return false;
      }
      if (this.form.activity_name !== null) {
        if (this.form.activity_name.length == 1) {
          // this.form.activity_name = this.form.activity_name[0].replace(/[^a-zA-Z0-9,()/& ]/g, "");
          this.form.activity_name = this.form.activity_name[0].replace(
            /[{}]/g,
            ""
          );
        }
      }
      if (this.form.sub_activity_name !== null) {
        if (
          this.form.sub_activity_name == "" ||
          this.form.sub_activity_name.substring(0, 1) == " "
        ) {
          this.form.sub_activity_name == null;
        }
      }
      if (this.form.actual_date == null) {
        this.showNotification({
          type: "error",
          message: "Please Fill Out Date Field",
        });
        return false;
      }
      if (this.form.activity_name == null) {
        this.showNotification({
          type: "error",
          message: "Please Fill Out Actual Field",
        });
        return false;
      }

      if (this.form.activity_name) {
        if (this.form.activity_name.length > 250) {
          this.showNotification({
            type: "info",
            message: "Actual Field Too long",
          });
          return false;
        }
      }

      if (this.hiddenOptions == true) {
        if (
          this.form.sub_activity_name == "Batal" &&
          (this.form.remark == null ||
            this.form.remark == "" ||
            this.form.remark.substring(0, 1) == " ")
        ) {
          // console.log('test')
          this.showNotification({
            type: "error",
            message: "Please Fill Out Remark Field",
          });
          return false;
        }
        if (this.form.sub_activity_name == null) {
          this.showNotification({
            type: "error",
            message: "Please Fill Out Options Field",
          });
          return false;
        }
      }
      if (this.hiddenReason == true) {
        if (this.form.reason == null) {
          this.showNotification({
            type: "error",
            message: "Please Fill Out Reason Field",
          });
          return false;
        }
      }

      // start loading
      this.isLoadingData = true;

      apiActualActivity
        .dispatch("SaveDataActualActivity", {
          id: this.idData,
          weekly_planning: this.form.weekly_planning,
          weekly_planning_detail: this.form.weekly_planning_detail,
          customer: this.form.customer_id,
          customer_mapping: this.form.customer_mapping,
          date: this.form.actual_date,
          po_id: this.form.po_id,
          remark: this.form.remark,
          expired_date: this.form.expired_date,
          processed_date: this.form.processed_date,
          activity_name: this.form.activity_name,
          activity_id: this.form.activity_id,
          sub_activity_name: this.form.sub_activity_name,
          sub_activity_id: this.form.sub_activity_id,
          reason: this.form.reason,
          coordinates: this.form.coordinates,
          estShipMonth: this.form.estShipMonth,
          projectStatus: this.form.statusCustomer,
          dataItemProducts: this.dataItemProducts,
          gpValue: this.form.GpValue,
          gpPercent: this.form.GpPercent,
          created_by: this.userData.nik,
          created_by_name: this.userData.fullname,
        })
        .then(() => {
          this.showNotification({
            type: "success",
            message: "Successfully Submitted",
          });
          this.$router.push({ name: "SFCActualActivity" });
        })
        .catch((error) => {
          let finalMessage = 'An unexpected system error occurred. Please contact support.';
          
          if (error.response && error.response.data && error.response.data.message) {
            let rawMessage = error.response.data.message;
            const matches = rawMessage.match(/"(.*?)"/g);

            if (matches && matches.length > 0) {
              finalMessage = matches[matches.length - 1].replace(/"/g, '');
            } else {
              finalMessage = rawMessage;
            }
          }

          this.showNotification({
            type: "error",
            message: finalMessage,
          });
          
          return false;
        })
        .finally(() => {
          // stop loading
          setTimeout(() => {
            this.isLoadingData = false;
          }, 500);
        });
    },
  },
  created() {
    this.setData();
    this.loadSizeRecap();
    // this.loadMeasurementRecap();
    this.loadBoxType();
  },
};
</script>
<style src="../SalesForce.scss" lang="scss" scoped />
<style>
.windowPC {
  display: block;
}
.windowMobac {
  width: 20%;
}
.windowMobnm {
  width: 20%;
}
@media only screen and (max-width: 800px) {
  .windowPC {
    display: none;
  }
  .windowMobac {
    width: 20%;
  }
  .windowMobnm {
    width: 20%;
  }
}
#POID {
  color: black !important;
}
.multiselect__option {
  font-size: 11px !important;
  white-space: initial !important;
  line-height: 1.5 !important;
}
.multiselect__option--selected:after {
  background: #f3f3f3;
}
.multiselect__tag {
  white-space: initial !important;
  line-height: 1.5 !important;
  font-size: 11px !important;
}
.accordion__item {
  padding: 0px !important;
  padding-bottom: 10px !important;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
